import React, { useEffect, useState } from 'react';
import '../ProfileCom/Profile.css';
import { MdOutlineModeEdit, MdStarOutline, MdStar, MdOutlineDelete } from "react-icons/md";
import { BsPlus } from "react-icons/bs";
import { Tooltip, message, Popconfirm } from 'antd';
import ProfileModal from '../ModalCom/profileModal';
import AddressModal from '../ModalCom/AddressModal';
import { API_BASE_URL, get } from '../../services/ApiRouting';
import Footer from "../FooterComponent/Footer";
import axios from 'axios';

const Profile = () => {
    // Read local storage initial values using lazy initializer
    const [profileData, setProfileData] = useState(() => {
        return JSON.parse(localStorage.getItem('profile') || 'null');
    });

    const accessToken = localStorage.getItem('access_token');
    const userId = profileData?.id || profileData?.user_id;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [editingAddress, setEditingAddress] = useState(null);
    const [allAddressData, setAlladdressData] = useState([]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const addressShowModal = (address = null) => {
        setEditingAddress(address);
        setIsAddressModalOpen(true);
    };

    const addressHandleCancel = () => {
        setIsAddressModalOpen(false);
        setEditingAddress(null);
    };

    // Callback function passed to ProfileModal to handle state updates seamlessly
    const handleProfileUpdate = (updatedUserData) => {
        setProfileData(updatedUserData);
    };

    const fetchAddresses = async () => {
        try {
            if (!userId) {
                setAlladdressData([]);
                return [];
            }

            const token = localStorage.getItem('access_token');

            // Include Authorization Header with Bearer Token
            const response = await get(`${API_BASE_URL}addresses?userId=${userId}`, {
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                }
            });

            console.log("addresses response:", response);
            const addressListData = response?.data || response?.list || [];
            setAlladdressData(addressListData);
            return addressListData;
        } catch (error) {
            console.error('Error fetching address data:', error);
            setAlladdressData([]);
            return [];
        }
    };

    useEffect(() => {
        fetchAddresses();
    }, [isAddressModalOpen, userId]);

    const setAddressAsDefault = async (elem) => {
        try {
            const addressId = elem?.id || elem?.address_id;
            if (!addressId) {
                throw new Error('Address ID not found');
            }

            const token = localStorage.getItem('access_token');

            // Include Authorization Token in request
            const response = await axios.patch(
                `${API_BASE_URL}addresses/${addressId}/default`, 
                { userId }, 
                {
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': token ? `Bearer ${token}` : ''
                    }
                }
            );

            if (response?.data?.success !== false) {
                message.success('Default address updated');
                await fetchAddresses();
            } else {
                throw new Error(response?.data?.message || 'Failed to set default address');
            }
        } catch (error) {
            console.error('Error updating default address:', error);
            message.error(error.response?.data?.message || error.message || 'Failed to update address');
        }
    };

 // In React (Profile.js)
const handleDeleteAddress = async (elem) => {
    try {
        const addressId = elem?.id || elem?.address_id;
        if (!addressId) throw new Error('Address ID not found');

        const token = localStorage.getItem('access_token');

        // Pass userId in query string: ?userId=${userId}
        const response = await axios.delete(`${API_BASE_URL}addresses/${addressId}?userId=${userId}`, {
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            }
        });

        if (response?.data?.success) {
            message.success('Address deleted successfully');
            await fetchAddresses();
        }
    } catch (error) {
        message.error(error.response?.data?.message || 'Failed to delete address');
    }
};

    // Construct image URL from backend relative path
    const profileImageUrl = profileData?.profile_image_url || profileData?.profile_image 
        ? (profileData?.profile_image_url || profileData?.profile_image).startsWith('http')
            ? (profileData?.profile_image_url || profileData?.profile_image)
            : `https://1fiveglobal.in${profileData?.profile_image_url || profileData?.profile_image}`
        : null;

    return (
        <>
            <section className='profile-section-details-con'>
                <div className='container'>
                    <div className='order-section-order-list-head'>
                        <h2>Profile</h2>
                    </div>

                    <div className='profile-section-personal-details-main-con'>
                        <div className='profile-section-avatar-con' style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '15px' }}>
                            {profileImageUrl ? (
                                <img 
                                    src={profileImageUrl} 
                                    alt="Profile Avatar" 
                                    style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #ddd' }} 
                                />
                            ) : (
                                <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                                    {profileData?.name?.charAt(0)?.toUpperCase() || 'U'}
                                </div>
                            )}

                            <div className='profile-section-personal-details-name'>
                                <h3>{profileData?.name} <span>(ID: {profileData?.id || profileData?.user_id})</span></h3> 
                                <div className='profile-section-personal-details-name-edit' onClick={showModal} style={{ cursor: 'pointer' }}>
                                    <MdOutlineModeEdit />
                                </div>
                            </div>
                        </div>

                        <div className='profile-section-persnoal-details-mail-contact-con'>
                            <div className='profile-section-persnoal-details-mail'>
                                <h3>Email</h3>
                                <h4>{profileData?.email}</h4>
                            </div>
                            <div className='profile-section-persnoal-details-mail'>
                                <h3>Phone number</h3>
                                <h4>{profileData?.phone || profileData?.contact}</h4>
                            </div>
                        </div>
                    </div>

                    <div className='profile-section-personal-details-main-con address-main-details'>
                        <div className='profile-section-personal-details-name'>
                            <h3>Addresses</h3>
                            <div className='profile-section-personal-details-name-edit' onClick={() => addressShowModal()} style={{ cursor: 'pointer' }}>
                                <BsPlus /> <span>Add</span>
                            </div>
                        </div>
                        <div className='profile-section-address-main-con'>
                            <div className='row'>
                                {allAddressData.map((elem) => {
                                    const isDefault = elem.is_default === 1 || elem.is_default === true || elem.is_default === "1";

                                    return (
                                        <div className='col-md-3' key={elem.address_id || elem.id}>
                                            <div className='profile-section-address-main' style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                                <div className='profile-section-address-con'>
                                                    {isDefault && (
                                                        <h3 style={{ color: '#faad14', fontSize: '12px', fontWeight: 'bold' }}>Default address</h3>
                                                    )}
                                                    <p className='address-type-style'>{elem?.address_type}</p>
                                                    <p>{elem?.name || elem?.full_name}</p>
                                                    <p>{elem?.address || elem?.address_line1}</p>
                                                    <p>{elem?.landmark || elem?.locality}</p>
                                                    <p>{elem?.pincode || elem?.postal_code} {elem?.city}</p>
                                                    <p>{elem?.state}</p>
                                                    <p>{elem?.alternative_number || elem?.alternative_phone || elem?.phone}</p>
                                                </div>

                                                {/* Action Icons replacing old buttons */}
                                                <div className='profile-section-address-icons-con' style={{ display: 'flex', gap: '12px', marginTop: '12px', justifyContent: 'flex-end', fontSize: '18px' }}>
                                                    {/* Edit Icon */}
                                                    <Tooltip title="Edit Address">
                                                        <span 
                                                            onClick={() => addressShowModal(elem)} 
                                                            style={{ cursor: 'pointer', color: '#1677ff' }}
                                                        >
                                                            <MdOutlineModeEdit />
                                                        </span>
                                                    </Tooltip>

                                                    {/* Default Star Icon */}
                                                    <Tooltip title={isDefault ? "Default Address" : "Set as Default"}>
                                                        <span 
                                                            onClick={() => !isDefault && setAddressAsDefault(elem)} 
                                                            style={{ cursor: isDefault ? 'default' : 'pointer', color: isDefault ? '#faad14' : '#8c8c8c' }}
                                                        >
                                                            {isDefault ? <MdStar /> : <MdStarOutline />}
                                                        </span>
                                                    </Tooltip>

                                                    {/* Delete Icon with confirmation popover */}
                                                    <Popconfirm
                                                        title="Delete Address"
                                                        description="Are you sure you want to delete this address?"
                                                        onConfirm={() => handleDeleteAddress(elem)}
                                                        destroyTooltipOnHide
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <span
                                                            title="Delete Address"
                                                            aria-label="Delete Address"
                                                            style={{ cursor: 'pointer', color: '#ff4d4f' }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </span>
                                                    </Popconfirm>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

            <ProfileModal
                isModalOpen={isModalOpen}
                handleOk={handleCancel}
                handleCancel={handleCancel}
                onProfileUpdate={handleProfileUpdate}
            />

            <AddressModal
                addressHandleOk={addressHandleCancel}
                addressHandleCancel={addressHandleCancel}
                fetchAddresses={fetchAddresses}
                allAddressData={allAddressData}
                addressShowModal={addressShowModal}
                isAddressModalOpen={isAddressModalOpen}
                editingAddress={editingAddress}
                onAddressSaved={fetchAddresses}
                onDeleteAddress={handleDeleteAddress}
                onSetDefaultAddress={setAddressAsDefault}
            />
        </>
    );
};

export default Profile;